// extracted by mini-css-extract-plugin
export var clickableWrapper = "_2x-2";
export var placeholderIcon = "_2x-3";
export var thumbnailCanvas = "_2x-1";
export var thumbnailWrapper = "_2x-0";